import React from 'react';
import FixedBottomNavBar from '../../../../components/FixedBottomNavBar';
import Button from '../../../../components/Button';
import { WidgetFormFooterStyle } from './style';

interface WidgetFormFooterProps {
  typeLabel: string;
  onClickPreview: () => void;
}

const WidgetFormFooter = (props: WidgetFormFooterProps) => {
  const { typeLabel, onClickPreview } = props;

  return (
    <FixedBottomNavBar>
      <WidgetFormFooterStyle>
        <div className="button-group">
          <div className="left">
            <Button color="light" text="미리보기" type="button" onClick={onClickPreview} />

            <div className="widget-type-info">
              <span>위젯 데이터: </span>
              <span className="type">{typeLabel}</span>
            </div>
          </div>

          <div className="right">
            <Button color="primary" text="저장" />
          </div>
        </div>
      </WidgetFormFooterStyle>
    </FixedBottomNavBar>
  );
};

export default WidgetFormFooter;
